import cornerstone from 'cornerstone-core';

const SLICE_SPACING_TOLERANCE = 0.1; 

const dot = (a, b) => a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
const cross = (a, b) => [
  a[1] * b[2] - a[2] * b[1],
  a[2] * b[0] - a[0] * b[2],
  a[0] * b[1] - a[1] * b[0],
];
const normalize = a => {
  const L = Math.hypot(a[0], a[1], a[2]) || 1;
  return [a[0] / L, a[1] / L, a[2] / L];
};

export function computePetVoxelVolumeMm3(petImageIds) {
  if (!petImageIds?.length) return null;
  const m0 = cornerstone.metaData.get('imagePlaneModule', petImageIds[0]);
  if (!m0) return null;

  const colSp = m0.columnPixelSpacing;
  const rowSp = m0.rowPixelSpacing;
  if (!colSp || !rowSp || colSp <= 0 || rowSp <= 0) return null;
  const inPlaneMm2 = colSp * rowSp;

  const planes = petImageIds
    .map(id => cornerstone.metaData.get('imagePlaneModule', id))
    .filter(p => p?.imagePositionPatient && p.rowCosines && p.columnCosines);

  let spacingMm = 0;

  if (planes.length > 1) {
    const normal = normalize(cross(planes[0].rowCosines, planes[0].columnCosines));
    const projs = planes
        .map(p => dot(p.imagePositionPatient, normal))
        .sort((a, b) => a - b);

    const span = projs[projs.length - 1] - projs[0];
    if (span > 0) {
      spacingMm = span / (projs.length - 1);
      let maxDev = 0;
      for (let i = 1; i < projs.length; i++) {
        maxDev = Math.max(maxDev, Math.abs(projs[i] - projs[i - 1] - spacingMm));
      }
      if (maxDev > SLICE_SPACING_TOLERANCE * spacingMm) {
        console.warn(
          `[SUV] non-uniform PET slice spacing (maxDev=${maxDev.toFixed(3)}mm) — voxel volume null`
        );
        return null;
      }
    }
  }

  if (!spacingMm || spacingMm <= 0) {
    console.warn('[SUV] could not determine PET slice spacing — voxel volume null');
    return null;
  }
  return inPlaneMm2 * spacingMm;
}
